const API_URL = "https://name-game-hdxh.onrender.com/search_name/?name=";

function getNameDetails(name) {
  return fetch(API_URL + name).then((response) => response.json());
}

export { getNameDetails };
